module.exports = __webpack_public_path__ + "static/media/water-tech.66ff481d.svg";